module.exports = __webpack_public_path__ + "img/SupplySubplatform.250f51f4.png";